let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gqAm3")).then(() => parcelRequire('185q6'));